import { z } from "zod";
import { TradingPeriodSchema } from "./strategies";

export const VariableDefinitionSchema = z.object({
  name: z.string(),
  hasPeriod: z.boolean(),
});

export const VariableDefinitionsSchema = z.array(VariableDefinitionSchema);

export const FunctionDefinitionSchema = z.object({
  name: z.string(),
  parameters: z.array(z.string()),
});

export const FunctionDefinitionsSchema = z.array(FunctionDefinitionSchema);

export const VariableValueQuerySchema = z.object({
  ticker: z.string().trim().min(1),
  bar: z.coerce.number().int().min(0),
});

export const GenerateBacktestRequestSchema = z.object({
  ticker: z.string().trim().min(1),
  tradingPeriod: TradingPeriodSchema,
  variablesCode: z.string(),
  criteriaCode: z.string(),
  entryCode: z.string().nullable(),
  withPrinting: z.boolean(),
});

export const BacktestTimeframeSummarySchema = z.object({
  timeframe: z.string(),
  wins: z.number(),
  losses: z.number(),
  winPct: z.number(),
  averageReturnPct: z.number(),
  differenceFromSpyPct: z.number(),
  totalChangePct: z.number(),
  annualizedReturnPct: z.number(),
  medianAnnualizedReturnPct: z.number(),
});

export const BacktestSummarySchema = z.object({
  ticker: z.string(),
  assetType: z.string(),
  strategyId: z.string(),
  subStrategyId: z.string().nullable(),
  timeframes: z.array(BacktestTimeframeSummarySchema),
});

export const BacktestTimeframeDetailSchema = z.object({
  timeframe: z.string(),
  timestamp: z.string(),
  changePct: z.number(),
  exitPrice: z.number(),
  change: z.number(),
});

export const BacktestDetailSchema = z.object({
  timestamp: z.string(),
  entryPrice: z.number(),
  timeframes: z.array(BacktestTimeframeDetailSchema),
});

export const BacktestSchema = z.object({
  ticker: z.string(),
  assetType: z.string(),
  strategyId: z.string(),
  subStrategyId: z.string().nullable(),
  results: z.array(BacktestDetailSchema),
});

export const BacktestGenerationResultSchema = z.object({
  backtest: BacktestSchema.nullable(),
  summary: BacktestSummarySchema.nullable(),
  avgExecutionMs: z.number().nullable(),
  compilerError: z.string().nullable(),
});

export type VariableDefinition = z.infer<typeof VariableDefinitionSchema>;
export type FunctionDefinition = z.infer<typeof FunctionDefinitionSchema>;
export type GenerateBacktestRequest = z.infer<typeof GenerateBacktestRequestSchema>;
export type BacktestGenerationResult = z.infer<typeof BacktestGenerationResultSchema>;
